import type { Theme } from "@mui/material";
import { css } from "@mui/material";

export const responsiveMargins = ({ theme }: { theme: Theme }) => css`
  padding-inline: clamp(
    ${theme.spacing(1)},
    ${theme.layout.gutter},
    ${theme.spacing(12)}
  );

  @media (max-width: ${theme.breakpoints.values.sm}px) {
    padding-inline: ${theme.spacing(1)};
    padding-left: ${theme.spacing(4)};
  }
`;
